import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ManualFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.38 17.16V5.34C4.38 3.92 5.54 2.66 7.04 2.66C8.06 2.66 8.94 3.26 9.38 4.08H18.16V16.9H8.06C7.98 16.6 7.68 16.12 7.04 16.12C6.46 16.12 6.02 16.62 6.02 17.16C6.02 17.7 6.46 18.2 7.24 18.2H15.62V19.84H7.04C5.54 19.84 4.38 18.58 4.38 17.16ZM6.02 5.34V14.68C6.34 14.56 6.68 14.48 7.04 14.48C7.4 14.48 7.74 14.56 8.06 14.68V5.34C8.06 4.8 7.62 4.3 7.04 4.3C6.46 4.3 6.02 4.8 6.02 5.34ZM11.14 7.58V9.26H15.08V7.58H11.14ZM11.14 11.12V12.8H15.08V11.12H11.14Z" />
    </SvgIcon>
  );
});
